import React, { useState } from 'react';
import { noticesMock } from './mockData';

import Header from './Header';
import { API_BASE_URL, ExpenseAddAPIEndpoint, ExpenseGetAPIEndpoint, ExpenseUpdateAPIEndpoint, ExpenseDeleteAPIEndpoint, ExpenseFileUploadAPIURL  } from '../constant';

import { useEffect } from 'react';
import "./css/paginationtable.css";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import {
  Form,
  Button,
  Row,
  Col,
  Card
} from "react-bootstrap";

export default function ExpenseForm() {
  const token = sessionStorage.getItem("JWTtoken");
const [searchParams] = useSearchParams();
useEffect(() => {

   const mode = searchParams.get("mode");
   if(mode === "edit") {  
    
    const data = localStorage.getItem("expenseData");

    if (data) {      
       const parsedData = JSON.parse(data);
        setExpense({expenseId: parsedData.expense_id,
        expenseDate: parsedData.expense_date,
        category: parsedData.category, 
        amount: parsedData.amount,
        gst: parsedData.gst_amount, 
        title: parsedData.expense_title, 
        vendor: parsedData.vendor_name,
        paymentMode: parsedData.payment_mode, 
        invoiceNo: parsedData.invoice_no,
        paidBy: parsedData.PaidByName, 
        status: parsedData.status, 
        description: parsedData.description,
        remarks: parsedData.remarks, 
        billImage: parsedData.bill_file,
        status: parsedData.expense_status,
        remarks: parsedData.remarks,
      });
      setExpenseId(parsedData.expense_id);   

      //set the date in the format dd-mm-yyyy for the input field
      const formattedDate = new Date(parsedData.expense_date);      
      setExpense((prevExpense) => ({
        ...prevExpense,
        expenseDate: parsedData.expense_date.substring(0, 10)
      }));
      // End of date formatting

      //start of payment mode mapping
      if(parsedData.payment_mode)
      {
        var value = "";
        switch (parsedData.payment_mode) {
          case "Cheque":
              value = "cheque";
            break;
             case "UPI":
              value = "upi";
            break;
             case "Bank Transfer":
              value = "bank";
            break;
             case "Cash":
              value = "cash";
            break;        
          default:
            break;
        }
        setExpense((prevExpense) => ({
          ...prevExpense,
          paymentMode: value
        }));
      }
      //end of payment mode mapping    

      // set image preview if billImage exists
      //alert("Before => " + parsedData.bill_file);
      setOldImageURL(parsedData.bill_file);
      if (parsedData.bill_file) {
        //Need to change this to the actual path where the image is stored on the server and it will be get from the API response. For now, we are using the bill_file name directly.
        if(parsedData.bill_file.startsWith("/") && parsedData.bill_file.length > 1 && (!parsedData.bill_file.endsWith(".pdf"))) {
          parsedData.bill_file = API_BASE_URL + "/uploads/" + parsedData.bill_file.substring(1);            
          setPreview(parsedData.bill_file);          
        }
        else
        {
          setPreview("PDF file cannot be previewed. Please download the file to view it.");
        }
        setIsImageChanged(false);
        
        //alert("After => " + parsedData.bill_file);
      }
      //end of image preview
    }
   }
   
     
}, []);



//   useEffect(() => {
//   const storedExpenseData = localStorage.getItem("expenseData");  

//   const jsonObject = JSON.parse(storedExpenseData);
//   setExpense({
//       ...jsonObject
//     });

//   alert("Stored Expense Data : " + storedExpenseData);
// });


const [expense, setExpense] = useState({
    expenseId: 0,
    expenseDate: "",
    category: "",
    amount: "",
    gst: "",
    title: "",
    vendor: "",
    paymentMode: "",
    invoiceNo: "",   
    paidBy: "",
    status: "Paid",
    description: "",
    remarks: "",
    billImage: null,
    total_amount: ""
  });


  const paymentModeOptions = [
  { value: "cash", label: "Cash" },
  { value: "upi", label: "UPI" },
  { value: "bank", label: "Bank Transfer" },
   { value: "cheque", label: "Cheque" },

];


const categoryOptions = [
  { value: "Electricity", label: "Electricity" },
  { value: "Water Bill", label: "Water Bill" },
  { value: "Security Salary", label: "Security Salary" },
  { value: "Housekeeping", label: "Housekeeping" },
  { value: "Lift Maintenance", label: "Lift Maintenance" },
  { value: "Garden Maintenance", label: "Garden Maintenance" },
  { value: "Cleaning", label: "Cleaning" },
  { value: "Plumbing", label: "Plumbing" },
  { value: "Electrical Repair", label: "Electrical Repair" },
  { value: "Generator", label: "Generator" },
  { value: "Office Expense", label: "Office Expense" },
  { value: "Stationery", label: "Stationery" },
  { value: "Internet", label: "Internet" },
  { value: "Festival", label: "Festival" },
  { value: "Event", label: "Event" }, 
  { value: "Legal", label: "Legal" },
  { value: "AMC", label: "AMC" },
  { value: "Property Tax", label: "Property Tax" },
  { value: "Other", label: "Other" }


];

 const paymentStatusOptions = [
  { value: "Paid", label: "Paid" },
  { value: "Pending", label: "Pending" },
  { value: "Failed", label: "Failed" },
  { value: "Refunded", label: "Refunded" }
 ];

 const [expenseId, setExpenseId] = useState(0);
const [image, setImage] = useState(null);
const navigate = useNavigate();




  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setExpense({
      ...expense,
      [name]: files ? files[0] : value
    });
  };

  const handleAmountChange = (e) => {    
  const { name, value } = e.target;

    let newValue = value;
    const amountFields = [
        "amount",
        "gst",
        "totalAmount",
        "paidAmount",
        "balanceAmount"
    ];

    if (amountFields.includes("amount")) {
        // Keep only digits, decimal point and minus
        newValue = value.replace(/[^0-9.-]/g, "");

        // Allow only one minus sign at the beginning
        newValue = newValue.replace(/(?!^)-/g, "");

        // Allow only one decimal point
        const parts = newValue.split(".");
        if (parts.length > 2) {
            newValue = parts[0] + "." + parts.slice(1).join("");
        }
    }

    setExpense((expense) => ({
        ...expense,
        [name]: newValue,
    }));
  };

  const [billFile, setBillFile] = useState(null);
  const [preview, setPreview] = useState("");

  const [loading, setLoading] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [error, setError] = useState("");

  const userType = sessionStorage.getItem("userType"); // or session
const isUserTypeAdmin = userType === "admin" ? true : false;
const userId = sessionStorage.getItem("userId"); // or session
const residentId = sessionStorage.getItem("residentId"); // or session 
const [isImageChanged, setIsImageChanged] = useState(false);
const [oldImageURL, setOldImageURL] = useState("");



  const handleFileChange = (e) => {
    const file = e.target.files[0];
    //alert("Selected file: " + file.name + " of type: " + file.type + " and size: " + file.size + " bytes");
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "image/png",
      "image/jpeg",
      "image/jpg"
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF, PNG, JPG, and JPEG files are allowed.");
      e.target.value = "";
      setBillFile(null);
      return;
    }

    // Optional: Maximum 2 MB
    if (file.size > 2 * 1024 * 1024) {
      alert("Maximum file size is 2 MB.");
      e.target.value = "";
      setBillFile(null);
      return;
    }

    alert("File selected: " + file.name);
    setBillFile(file);
    
    alert("File set for upload: " + file.name);

    if (file) {
        //setPreview("PDF file cannot be previewed. Please download the file to view it.");
        if(file.name.length > 1 && (!file.name.endsWith(".pdf"))){
          setPreview(URL.createObjectURL(file));
        }
        setIsImageChanged(true);
        setOldImageURL("");
    }

  };


  const fetchExpenses = async () => {
    
      try {
        const apiURL = API_BASE_URL + ExpenseGetAPIEndpoint;
        const response = await fetch(apiURL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        } });
        const data = await response.json();

        if (data.status) {
          setExpenses(data.data);
        } else {
          setError(data.message || "Failed to fetch expenses");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };



  


  const handleSubmit = async (e) => {
    e.preventDefault();

    //alert(JSON.stringify(expense));
    
    const formData = new FormData();
     const payload = {
           ...expense,                 // existing form fields
           total_amount : parseFloat(expense.gst) + parseFloat(expense.amount),
           "billImage": billFile,  // Assuming you want to send the file name; adjust as needed
           "gst": parseFloat(expense.gst),
           "amount": parseFloat(expense.amount),
            createdby : isUserTypeAdmin ? userId : residentId,
            updatedby : isUserTypeAdmin ? userId : residentId,
            isImageChanged : isImageChanged ? true : false,
            oldImageLink : oldImageURL
        };       
        //alert(JSON.stringify(payload));
        //console.log(payload);


    try {
       const url  = API_BASE_URL + ExpenseAddAPIEndpoint;     
      if( 1=== 1 || expenseId === 0) {
        setLoading(true);
       
      Object.keys(payload).forEach((key) => {
        formData.append(key, payload[key]);
      });

      const response = await fetch(url,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: formData
      });

    const result = await response.json();
    alert("Response from server : " + JSON.stringify(result));
      return;
      if (result.status) 
      {
          alert("Expense added successfully.");
          setExpense({
            expenseId: 0,
            expenseDate: "",
            category: "",
            amount: "",
            gst: "",
            title: "",
            vendor: "",
            paymentMode: "",
            invoiceNo: "",   
            paidBy: "",
            status: "Paid",
            description: "",
            remarks: "",
            billImage: null,
            total_amount: ""
          });

          // Redirect to expenses list page
          navigate("/Expenses/List");

          
          //fetchExpenses(); // Refresh the expenses list
      } 
      else 
      {
        alert("Error : " + result.message);      
      }
    }
  }
  catch (error) 
    {
      setLoading(false);
      alert("Server error".error);
    } 
    finally
    {
      alert("Csll fina;lly");
      setLoading(false);
    }
  };
 
  return ( <>
    <Header/>

    
      <h4>{(expenseId === 0 ? "Add" : "Edit")} Society Expense <button style={{ float : "right"  }} onClick={() => navigate("/Expenses/List")}>
    Go to List
</button></h4> 
      {loading && <Loader />}
      <form onSubmit={handleSubmit} className="payment-form">
        {/* Flat No */}
        <div className="form-group">
          <label>Expense Date</label>
          <input 
            type="date"
            name="expenseDate"
            value={expense.expenseDate} 
            onChange={handleChange}
            required
          />
        </div>


        {/* Select Category Type */}
        <div className="form-group">
          <label>Category</label>
          <select name="category" value={expense.category} onChange={handleChange} required>
            <option value="">Select Category Type</option>
            {categoryOptions.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>

         {/* Amount */}
        <div className="form-group">
          <label>Amount</label>
          <input
            type="number"
            name="amount"
            value={expense.amount}
            onChange={handleAmountChange}
            placeholder="Enter amount"
            required
          />
        </div>

        {/* GST Amount */}
        <div className="form-group">
          <label>GST Amount</label>
          <input
            type="number"
            name="gst"
            value={expense.gst}
            onChange={handleAmountChange}
            placeholder="Enter GST amount"
          />
        </div>

        {/* Expense Title */}
        <div className="form-group">
          <label>Expense Title</label>
          <input
            type="text"
            name="title"
            value={expense.title}
            onChange={handleChange}
            placeholder="Expense Title"
            required
          />
        </div>

        {/* Vendor name */}
        <div className="form-group">
          <label>Vendor</label>
          <input
            type="text"
            name="vendor"
            value={expense.vendor}
            onChange={handleChange}
            placeholder="Enter Vendor name"
            required
          />
        </div>
        
            
        {/* Payment Mode */}
        <div className="form-group">
          <label>Payment Mode</label>
          <select name="paymentMode" value={expense.paymentMode} onChange={handleChange} required>
            <option value="">Select Payment Mode</option>
            {paymentModeOptions.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
          
          {/* Invoice No */}
        <div className="form-group">
          <label>Invoice No</label>
          <input
            type="text"
            name="invoiceNo"
            value={expense.invoiceNo}
            onChange={handleChange}
            placeholder="Enter Invoice Number"
          />
        </div>
        
         
          <div>
            <label>Upload Bill</label>
             <input
                type="file"
                name="billImage"
                accept=".pdf,.png,.jpg,.jpeg"
                onChange={handleFileChange}
              />
               {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  width="150"
                />
              )}
            </div>
        {/* Paid By */}
        <div className="form-group">
          <label>Paid By</label>
          <input
            type="text"
            name="paidBy"
            value={expense.paidBy}
            onChange={handleChange}
            placeholder="Enter Paid By"
            required
          />
        </div>

<div className="form-group">
          <label>Payment Status</label>
          <select name="status" value={expense.status} onChange={handleChange} required>
            <option value="">Select Payment Status</option>
            {paymentStatusOptions.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>

 {/* Description */}
        <div className="form-group">
          <label>Description</label>
         <textarea
            type="textarea"
            name="description"
            value={expense.description}
            onChange={handleChange}
            placeholder="Enter Description"
            required
          />
        </div>


{/* Remarks */}
        <div className="form-group">
          <label>Remarks</label>
          <textarea
            type="textarea"
            name="remarks"
            value={expense.remarks}
            onChange={handleChange}
            placeholder="Enter Remarks"
            required
          />
        </div>
        

       <div className="form-group">
          <button type="submit" class="btn-approve" style={{ width: "50%" }}>
            {(expenseId === 0 ? "Insert" : "Update")}
          </button>

          <button type="button"  class="btn-cancel" style={{ width: "50%" }} onClick={() => navigate("/Expenses/List")}>
            Cancel
          </button>
        </div>

        

      </form>
    
  </>);

  
}